import React from 'react';
import './hyperlink.scss';

function Hyperlink({ hyperlinkData }) {
  return (
    <a className="hyperLink" href={hyperlinkData.href} target="_blank" rel="sponsored">
      {hyperlinkData.a}
    </a>
  );
}

export default Hyperlink;
